import { Divider } from 'antd';
import styled from 'styled-components';

export default styled(Divider)`
	// Add your styles here
`;
